import { createUseFoundationHook, createUseSurfaceHook, } from '@clds/design-system-foundations';
const foundationSizeToChipSize = {
    xxs: 'xxs',
    xs: 'xxs',
    sm: 'sm',
    md: 'sm',
    lg: 'md',
    xl: 'md',
    xxl: 'md',
};
const chipSizeToInnerFoundationSize = {
    md: 'sm',
    sm: 'xxs',
    xxs: 'xs',
};
const surfaceToneToChipTone = {
    subtle: 'solid',
    solid: 'subtle',
};
export const { useFoundation } = createUseFoundationHook(({ size }) => ({ size: foundationSizeToChipSize[size] }), ({ size }) => ({ size: chipSizeToInnerFoundationSize[size] }), { size: 'md' });
export const { useSurface } = createUseSurfaceHook(({ variant, tone }) => ({ variant, tone: surfaceToneToChipTone[tone] }), ({ variant, tone }) => ({ variant, tone }), { variant: 'secondary', tone: 'solid' });
//# sourceMappingURL=foundationMapping.js.map